import { createClientRpc } from '@tanstack/react-start/client-rpc';
import { saveAuthCookie } from "@/lib/cookies";
import { captureError, captureMessage } from "@/lib/pulse-telemetry";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { useTranslation } from "@/lib/paraglide-react";
export const validateState = createServerFn({
  method: "GET"
}).handler(createClientRpc("f4dff28e665778e49ebd6d2f43f67c89b637c21f72bd489876ab11d0c5e6c93c"));
export const getTokens = createServerFn({
  method: "GET"
}).handler(createClientRpc("d4836fba96bf63ab1dadb9f2a95f0cf682314a4f3b7d028c28eea1512b169b1d"));
export const Route = createFileRoute("/auth/callback")({
  component: () => {
    const {
      t
    } = useTranslation();
    return <div>{t("auth.callback.placeholder")}</div>;
  },
  beforeLoad: async ({
    location
  }) => {
    let crypto: Crypto;
    if (import.meta.env.SSR) {
      // @ts-expect-error
      crypto = await import("node:crypto");
    } else {
      crypto = window.crypto;
    }
    const searchParams = new URLSearchParams(location.searchStr);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    if (!code || !state) {
      throw redirect({
        to: "/{-$locale}",
        search: {
          error: "invalid_request"
        }
      });
    }
    const stateValid = await validateState({
      data: state
    });
    if (!stateValid) {
      throw redirect({
        to: "/{-$locale}",
        search: {
          error: "invalid_state"
        }
      });
    }
    const tokens = await getTokens({
      data: code
    }).catch(error => {
      console.error(error);
      captureError(error, {
        source: "auth.callback.tokens"
      });
      throw redirect({
        to: "/{-$locale}",
        search: {
          error: "invalid_request"
        }
      });
    });
    const id = crypto.randomUUID().replaceAll("-", "").toUpperCase();
    const token = await saveAuthCookie({
      data: JSON.stringify({
        name: "EGDATA_AUTH",
        value: {
          ...tokens,
          jti: id
        }
      })
    });
    const persistResponse = await fetch("https://api.egdata.app/auth/v2/persist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!persistResponse.ok) {
      const errorBody = await persistResponse.json();
      console.error("Failed to persist tokens", errorBody);
      captureMessage("Failed to persist auth tokens", {
        attributes: {
          "http.response.status_code": persistResponse.status
        },
        source: "auth.callback.persist"
      });
      throw redirect({
        to: "/{-$locale}",
        search: {
          error: "persist_error"
        }
      });
    }
    throw redirect({
      to: "/{-$locale}"
    });
  }
});